module.exports = __webpack_public_path__ + "img/logo_wb.5feae55d.png";